export default function GraphToggle({ shown, onToggle }: { shown: boolean; onToggle: () => void }) {
  return (
    <button type="button" className="btn ghost sm" aria-expanded={shown} onClick={onToggle} style={{ marginLeft: 'auto', height: 28, padding: '0 10px' }}>
      {shown ? 'Hide graph' : 'Graph'}
    </button>
  );
}
